import { ILogin, PostApiResponse } from "../../../types/types";
import { getRequestData } from "../../../services/utils/utils";
const api = import.meta.env.VITE_API_URL;

export const authApi = {
  login: async (payload: ILogin): Promise<string | undefined> => {
    const url = `${api}/login`;
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(payload),
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });

    const data = await getRequestData<PostApiResponse>(response);
    if (!response.ok) {
      return data.message;
    }
    return undefined;
  },

  verifySession: async (): Promise<boolean> => {
    const url = `${api}/session`;
    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
    });
    return response.ok;
  },

  logout: async (): Promise<void> => {
    const response = await fetch(`${api}/logout`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => "");
      throw new Error(errorText || `Logout failed with status ${String(response.status)}`);
    }
  },
};
